import { render, staticRenderFns } from "./walletlist.vue?vue&type=template&id=27d2325b&scoped=true"
import script from "./walletlist.vue?vue&type=script&lang=js"
export * from "./walletlist.vue?vue&type=script&lang=js"
import style0 from "./walletlist.vue?vue&type=style&index=0&id=27d2325b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2325b",
  null
  
)

export default component.exports